import gql from 'graphql-tag';

const returnInvoiceAuditsQuery = gql`
  query returnInvoiceAudits(
    $returnInvoiceId: Int!
    $startDate: String
    $endDate: String
    $size: Int
    $offset: Int
  ) {
    returnInvoiceAudits(
      returnInvoiceId: $returnInvoiceId
      startDate: $startDate
      endDate: $endDate
      size: $size
      offset: $offset
    ) {
      id
      whodunnit
      event
      versionAuthor
      itemType
      changeset
      timeStamp
    }
  }
`;

export default returnInvoiceAuditsQuery;
